import * as Yup from 'yup'

import { useEffect, useState } from "react"

import { INumberProps } from './INumberProps'

export const useNumberValidationSchema = (props: INumberProps) => {
    const [schema, setSchema] = useState<Yup.NumberSchema>();

    useEffect(() => {
        const { label, placeholder, required, minValue, maxValue } = props

        let schema = Yup.number()
        if (required)
            schema = schema.required();

        if (label)
            schema = schema.label(label);
        else if (placeholder)
            schema = schema.label(placeholder);

        if (minValue !== undefined)
            schema = schema.min(minValue);

        if (maxValue !== undefined)
            schema = schema.max(maxValue);

        setSchema(schema)
        // eslint-disable-next-line
    }, [props])

    return schema
}
